module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Catalog_List_Content', {

		configure: function () {
			this.moreEventsAvailable = true;
			this.masonryApplied = false;
			this.searchKeyword = false;

			this.eventsAliases = {
				1: 'liveshow',
				2: 'post',
				3: 'message',
				4: 'trip',
				5: 'custom',
				6: 'photoset',
				7: 'video',
				8: 'join'
			};

			this.contentTypes = {
				1: 'Liveshow',
				2: 'Post',
				3: 'Photoset',
				4: 'Video',
				'Liveshow': 1,
				'Post': 2,
				'Photoset': 3,
				'Video': 4
			};/*[1, 2, 6, 7];*/
			
			this.registerOptions('', {
				'!scrollHandlerPath': '@parent @parent @parent #scrollHandler',
				template: 'catalog_home_models_grid',
				widgets: {
					eventsFilter: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-filter',
						template: 'catalog_filter_content',
						widgets: {
							search: {
								widget: 'Widget',
								autoRender: true,
								container: '.form-group.search',
								template: 'catalog_search_input'
							}
						},

						handleDom: {
							selectChange: {
								target: 'select',
								event: 'change',
								callback: '@parent:_handleSelectChange'
							},
							clearSearch: {
								targetWidget: '#search',
								target: '.icon.clear',
								event: 'click',
								callback: '@parent:_clearSearch'
							},
							search: {
								targetWidget: '#search',
								target: '.search-start',
								event: 'click',
								callback: '@parent:_searchByName'	
							}
						},

						handleWom: {
							searchFormSubmit: {
								widget: '#search',
								event: 'search_form_submit',
								callback: '@parent:_searchByName'
							}
						},

						'hooks.onAddedToDom': fox.bind(function () {
							var sortContent = fox.Navigator.get('sortContent');
							var type = fox.Navigator.get('type');
							var name = fox.Navigator.get('contentName');

							if (sortContent) {
								this.updateFilterOnLoad('sortContent', sortContent, true);
							}

							if (type) {
								this.updateFilterOnLoad('type', type, true);
							}

							if (name) {
								this.updateFilterOnLoad('contentName', name);
							}
						}, this)
					},
					eventsList: {
						'widgets.list.tpl.row': 'catalog_events_item_model_profile'
					}
				},
				handleWom: {
					'!_handleScrolling.widget': '@parent @parent @parent #scrollHandler'
				}
				
			});

			this.callParent('configure', arguments);

			this.searchParams = ['type', 'contentName', 'sortContent'];
			this.sortingTypes = {
				'-1': 'Last Added',
				1: 'A-Z',
				'Last Added': -1,
				'A-Z': 1
			};
		},

		activate: function (argument) {
			this.callParent('activate', arguments);
			
			this.resetPager();
		},

		_handleSelectChange: function (el, skipEvent) {
			var opt = el.options[el.selectedIndex];
			var parent = el.parentNode;
			$('.txt', parent).text(opt.innerHTML);


			if (skipEvent === true) {
				return;
			}

			this.dispatchEvent('select_changed', {name: el.name, value: opt.value});
		},

		_handleFilterChange: function (data) {
			this.masonryApplied = false;

			switch (data.name) {
				case 'type':
				case 'sortContent':
					if (data.value < 0) {
						this.setFilterParams(data.name, false);
						this.loadEvents();

						return;
					}

					this.setFilterParams(data.name, data.value);
				break;
			}

			this.loadEvents();
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('contentName', false);
			this.wom1('#eventsFilter #search').dom1('#search-by-name').value = '';

			this.loadEvents();
		},

		updateFilterOnLoad: function (alias, value, skipEvent) {
			switch (alias) {
				case 'contentName':
					this.updateNameInput(value);
				break;

				case 'sortContent':
					this.updateSelect('sortContent', value, skipEvent);
				break;

				case 'type':
					this.updateSelect('type', this.contentTypes[value], skipEvent);
				break;
			}
		},

		updateSelect: function (name, value, skipEvent) {
			var el = this.wom1('#eventsFilter').dom1('[name="' + name + '"]');

			if (!el) {
				return;
			}
			
			$(el).find('option').each(function (i, opt) {
				opt.selected = false;

				if (opt.value == value) {
					opt.selected = true;
				}
			});

			this._handleSelectChange(el, skipEvent);

		},

		updateNameInput: function (value) {
			this.rwom1('#eventsFilter #search').dom1('#search-by-name').value = window.decodeURI(value);
		},

		prepareResponse: function (response, alias) {
			var collection = response.collection;

			fox.each(collection, function (data) {
				data.eventAlias = this.eventsAliases[data.type];

				if (data.type == 2) {
					data.link  = [data.link, 'post', data._typedParams.id].join('/');
				}

				if (data.type == 1 || data.type == 7) {
					data.useSlideShow = true;
				}

				if (data.type == 1 && data._typedParams.status == 0 && new Date(data.startDate) < new Date()) {
					data.liveshowSkiped = true
					//data._typedParams.status = 1
				}

				if (fox.inArray(fox.getObjectKeys(this.contentTypes), data.type) && data.title) {
					data.link = [data.link, fox.utils.toNavigatorAlias(data.title)].join('/');
				}
			}, this);

			//console.log(response)
			this.wom1('#' + alias)._apiResponse = response.dataLayer || response;
		},

		_searchByName: function (obj, w, e) {
			var value = this.wom1('#eventsFilter #search').dom1('#search-by-name').value;
			//console.log('_searchByName', value);

			this.searchKeyword = value;

			if (!fox.trim(value).length) {
				this._clearSearch();

				return;
			};

			this.searchByName(value);

			return false;
		},

		searchByName: function (str) {
			this.masonryApplied = false;
			this.searchKeyword = str;

			this.setFilterParams('contentName', str);

			this.loadEvents();
		},

		/*prepareSearchParams: function (id) {
			this.callParent('prepareSearchParams', arguments);

			if (id) {
				this.eventsDl._transitParameters['clientId'] = id;
				this.moreEventsDl._transitParameters['clientId'] = id;
			}
		},*/

		prepareSearchParams: function (id) {
			this._resetDls();
			//this.eventsDl._transitParameters = {};
			//this.moreEventsDl._transitParameters = {};


			fox.each(this.searchParams, function (param) {
				var val = fox.Navigator.get(param);

				if (param === 'type') {
					val = this.contentTypes[val];
				}

				if (param === 'sortContent') {
					val = this.sortingTypes[val];
				}

				if (val) {
					this.setTransitParameter(param, val);
				}
			}, this);

			if (id) {
				this.eventsDl._transitParameters.clientId = id;
				this.moreEventsDl._transitParameters.clientId = id;
			}
		},

	}, 'Catalog_List');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/list/content.js
// module id = 119
// module chunks = 0